<template>
  <div class="exception">
    <div class="content">
      <h1>503</h1>
      <div class="desc">
        <span>服务器维护中，预计将持续至 </span>
        <span style="font-weight: 700; color: var(--color-red)">{{ maintenanceUntil }}</span>
        <span>，请耐心等待</span>
      </div>
      <div class="action">
        <a-button type="primary" @click="tryAgain()">刷新状态</a-button>
      </div>
    </div>
    <div class="img">
      <img src="../../assets/500.svg" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      maintenanceUntil: '',
    }
  },
  created() {
    this.maintenanceUntil = localStorage['maintenanceUntil']
  },
  methods: {
    tryAgain() {
      this.$router.push({ path: '/user' })
    },
  },
}
</script>

<style lang="less" scoped>
.exception {
  text-align: center;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh);
  justify-content: center;

  .img {
    display: inline-block;
    // padding-right: 52px;
    zoom: 1;
    img {
      height: 360px;
      max-width: 430px;
    }
  }
  .content {
    h1 {
      color: #434e59;
      font-size: 72px;
      font-weight: 600;
      line-height: 72px;
      margin-bottom: 24px;
    }
    .desc {
      color: rgba(0, 0, 0, 0.45);
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 16px;
    }
  }
}

.mobile {
  .exception {
    .img {
      padding-right: unset;

      img {
        height: 40%;
        max-width: 80%;
      }
    }
  }
}
</style>